import { MutableRefObject, useEffect, useRef, useState } from 'react';

interface HookApi {
  stageParentRef: MutableRefObject<Nullable<HTMLDivElement>>;
  canvasDimensions: { width: number; height: number };
}

export const useCanvasDimensions = (): HookApi => {
  const stageParentRef = useRef<Nullable<HTMLDivElement>>(null);

  const [canvasDimensions, setCanvasDimensions] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const container = stageParentRef.current;

    if (!container) return;

    const updateDimensions = (): void => {
      const containerWidth = container.offsetWidth || 0;
      const containerHeight = container.offsetHeight || 0;
      setCanvasDimensions({ width: containerWidth, height: containerHeight });
    };

    updateDimensions();

    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => {
        updateDimensions();
      });

      observer.observe(container);

      return () => {
        observer.disconnect();
      };
    }

    window.addEventListener('resize', updateDimensions);
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  return {
    stageParentRef,
    canvasDimensions,
  };
};
